// extracted by mini-css-extract-plugin
export default {"fabContainer":"docsMobile_fabContainer__EAFej","fab":"docsMobile_fab__whw9y","overlay":"docsMobile_overlay__CO4xp","drawer":"docsMobile_drawer__iPbpX"};